<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div  class="animated fadeIn">
    <template v-if="base">
      <List v-show="list" ref="list" />
    </template>
    <Detail v-if="detail" @refresh="refresh" />
    <!-- <MDetail v-if="mdetail" @refresh="refresh" /> -->
  </div>
</template>

<script>


import List from './Webshell.List';
import Detail from './Webshell.Detail';

export default {
  components: { List, Detail },
  data: () => ({ base: false, list: false, detail: false }),
  methods: {
    refresh() {
      console.log("refresh", this.$refs.list.$children)
      if(this.$refs.list) {
        this.$refs.list.$children.forEach(ch => {
          // console.log("refresh children", ch)
          ch.$children ? ch.$children.forEach(c => {
            // console.log("refresh children c", c)
            if(c.refresh != undefined) {
              c.refresh()
            }

            c.$children && c.$children.forEach(cc => {
              // console.log("refresh children cc", cc.refresh)
              if(cc.refresh != undefined) { cc.refresh() }
            })

          }) : ch.refresh()
        })
      }
    },
    select({ id, tag }) {
      // console.log(id, tag)
      if(id) { this.list = false; this.detail = true;}
      else { this.detail = false; this.base = this.list = true;  }
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('[vue] webshell', 'route changed', to.param);
      this.select(to.params, to.name);
    }
  },
  created: function() { console.log('[vue] webshell', 'created'); },
  destroyed: function() { console.log('[vue] webshell', 'destroyed'); },
  mounted: function() {
    console.log('[vue] webshell', 'mounted');
    this.select(this.$route.params);
  },
}
</script>
